import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { getSessionStoragePrefs, setSessionStoragePrefs } from "./Storage";
import Article from "./components/Article";
import Collection from "./components/Collection";
import CollectionList from "./components/CollectionList";
import { AppContext } from "./appContext";
import ChatTabsList from "./components/ChatTabsList";
import { HC_ACTIVE_COMPONENT, HC_ACTIVE_ID, HC_SEARCH_TEXT } from "./globals";
export default function HelpCenter() {
    var parentContext = useContext(AppContext);
    var setPromtWidth = parentContext.setPromtWidth;
    var HCComponentNames;
    (function (HCComponentNames) {
        HCComponentNames["CollectionList"] = "CollectionList";
        HCComponentNames["Collection"] = "Collection";
        HCComponentNames["Article"] = "Article";
    })(HCComponentNames || (HCComponentNames = {}));
    var _a = useState([]), collections = _a[0], setCollections = _a[1];
    var _b = useState([]), articles = _b[0], setArticles = _b[1];
    var _c = useState(), activeCollection = _c[0], setActiveCollection = _c[1];
    var _d = useState(), activeArticleId = _d[0], setActiveArticleId = _d[1];
    var _e = useState(HCComponentNames[(getSessionStoragePrefs(HC_ACTIVE_COMPONENT) != null
        ? getSessionStoragePrefs(HC_ACTIVE_COMPONENT)
        : HCComponentNames.CollectionList)]), activeComponentName = _e[0], setActiveComponentName = _e[1];
    var _f = useState(getSessionStoragePrefs(HC_SEARCH_TEXT) != null
        ? getSessionStoragePrefs(HC_SEARCH_TEXT)
        : ""), searchTxt = _f[0], setSearchTxt = _f[1];
    useEffect(function () {
        setSessionStoragePrefs(HC_ACTIVE_COMPONENT, activeComponentName);
    }, [activeComponentName]);
    useEffect(function () {
        setSessionStoragePrefs(HC_SEARCH_TEXT, searchTxt);
    }, [searchTxt]);
    var openCollection = function (collectionId) {
        setSessionStoragePrefs(HC_ACTIVE_ID, collectionId);
        setActiveCollection(collections.find(function (collection) { return collection.id == collectionId; }));
        setActiveComponentName(HCComponentNames.Collection);
    };
    var openArticle = function (articleId) {
        setSessionStoragePrefs(HC_ACTIVE_ID, articleId);
        setActiveArticleId(articleId);
        setActiveComponentName(function (previous) {
            if (previous == HCComponentNames.CollectionList)
                setActiveCollection(undefined);
            return HCComponentNames.Article;
        });
    };
    var backToCollectionList = function () {
        setSessionStoragePrefs(HC_ACTIVE_ID, null);
        setActiveComponentName(HCComponentNames.CollectionList);
    };
    var backToCollection = function (collectionId) {
        if (searchTxt && !activeCollection)
            backToCollectionList();
        else {
            setSessionStoragePrefs(HC_ACTIVE_ID, collectionId);
            setActiveComponentName(HCComponentNames.Collection);
        }
    };
    useEffect(function () {
        setSessionStoragePrefs(HC_ACTIVE_COMPONENT, activeComponentName);
    }, [activeComponentName]);
    return (_jsxs(_Fragment, { children: [(function () {
                switch (activeComponentName) {
                    case HCComponentNames.Article: {
                        return (_jsx(Article, { articleId: activeArticleId, backToCollection: backToCollection }));
                    }
                    case HCComponentNames.Collection: {
                        return (_jsx(Collection, { collection: activeCollection, setCollection: setActiveCollection, openArticle: openArticle, backToCollectionList: backToCollectionList }));
                    }
                    case HCComponentNames.CollectionList: {
                        return (_jsx(CollectionList, { openCollection: openCollection, setCollections: setCollections, collections: collections, setArticles: setArticles, searchTxt: searchTxt, openArticle: openArticle, setSearchTxt: setSearchTxt, articles: articles }));
                    }
                    default:
                        return _jsx(_Fragment, {});
                }
            })(), activeComponentName == HCComponentNames.CollectionList ||
                activeComponentName == HCComponentNames.Collection ? (_jsx(ChatTabsList, {})) : (_jsx(_Fragment, {}))] }));
}
